import { Star } from "lucide-react";

import { Avatar } from "./Avatar";

export function TeamWaitingList({ admin, onAction, waiting }) {
  return (
    <section className="waitlist-showcase" data-testid="waiting-list">
      <header>
        <div>
          <span>LISTA DE ESPERA</span>
          <h2>Para domingo</h2>
        </div>
        <strong data-testid="waiting-list-count">{waiting.length}</strong>
      </header>
      {waiting.length ? (
        <div className="waitlist-cards">
          {waiting.map((player) => (
            <article className="waitlist-player" key={player.id} data-testid={`waiting-player-${player.id}`}>
              <div className="waitlist-avatar">
                <Avatar user={player} />
              </div>
              <div className="waitlist-copy">
                <strong>{player.name}</strong>
                <small>
                  <Star size={12} fill="currentColor" />
                  {player.rating.toFixed(1)}
                </small>
              </div>
              {admin && (
                <button
                  className="button button-secondary compact"
                  onClick={() => onAction(`/matches/current/release-guest/${player.id}`)}
                  data-testid={`release-guest-${player.id}`}
                >
                  Liberar
                </button>
              )}
            </article>
          ))}
        </div>
      ) : (
        <p className="waitlist-empty" data-testid="waiting-list-empty">
          Nenhum avulso aguardando.
        </p>
      )}
      {admin && waiting.length > 0 && (
        <button
          className="button button-primary waitlist-release"
          onClick={() => onAction("/matches/current/release-guests")}
          data-testid="release-all-guests-button"
        >
          Liberar avulsos automaticamente
        </button>
      )}
    </section>
  );
}